export default {
      id: "icon-flip-usage",
      viewBox: "0 0 26 20",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#icon-flip",
      toString: function () {
        return this.url;
      }
    }